import { createContextHook } from '@/utils';
import { EntryModalContext } from './EntryModalContext';

export const useEntryModalContext = createContextHook(EntryModalContext);
